import axios from "axios";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// We read REACT_APP_BACKEND_URL at build time. If it's missing OR if it points
// at a different origin than the one the user is currently viewing the app from
// (a deploy misconfiguration we just hit on app.themeadowsmindset.com), we fall
// back to the current window origin so auth cookies always set on the right host.
const BUILD_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const RUNTIME_ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

function pickBackendUrl() {
  // If no build-time value is present, use the runtime origin (same-origin call).
  if (!BUILD_BACKEND_URL) return RUNTIME_ORIGIN;
  // If the build value matches the runtime origin, use it as-is.
  try {
    const buildHost = new URL(BUILD_BACKEND_URL).host;
    const runtimeHost = new URL(RUNTIME_ORIGIN).host;
    if (buildHost === runtimeHost) return BUILD_BACKEND_URL;
    // Cross-origin mismatch — log it and fall back to runtime origin so the cookie
    // gets set on the host the user is actually on. This prevents the entire
    // class of bugs where the prod build was compiled with the preview backend URL.
    // eslint-disable-next-line no-console
    console.warn(
      `[api.js] REACT_APP_BACKEND_URL host (${buildHost}) differs from current origin (${runtimeHost}). ` +
      `Falling back to current origin so auth cookies set on the correct host. ` +
      `Update REACT_APP_BACKEND_URL on this deployment to silence this warning.`
    );
    return RUNTIME_ORIGIN;
  } catch (_) {
    return RUNTIME_ORIGIN || BUILD_BACKEND_URL;
  }
}

const BACKEND_URL = pickBackendUrl();
export const API = `${BACKEND_URL}/api`;

// Auth is carried by an httpOnly `mm_token` cookie set by the backend on
// /auth/login and /auth/register. We just need axios to send cookies on every
// request — no more localStorage tokens, no more Authorization header.
export const api = axios.create({ baseURL: API, withCredentials: true });

// Global Premium-gate detector — anytime the backend says 403 with a Premium-related message,
// dispatch a window event so UpgradeModal can react.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const detail = err.response?.data?.detail || "";
    if (status === 403 && /premium|free tier|upgrade/i.test(detail)) {
      window.dispatchEvent(new CustomEvent("mm:upgrade-prompt", { detail: { message: detail } }));
    }
    return Promise.reject(err);
  }
);

// One-time cleanup: purge legacy localStorage token from pre-cookie deploys so
// nothing in the app accidentally reaches for it.
try { localStorage.removeItem("mm_token"); } catch (_) { /* noop */ }
